// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CustomCard Component Styles */

.custom-card {
  border-radius: 20px;
  padding-top: var(--space-sm);
  display: flex;
  flex-direction: column;
  justify-content: top;
  transition: all var(--duration-fast) var(--easing-ease-out);
  position: relative;
  overflow: hidden;
}

.custom-card--clickable {
  cursor: pointer;
}

.custom-card--clickable:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.custom-card--clickable:active {
  transform: translateY(0);
}

/* Primary variant: Dark blue background with white text */
.custom-card--primary {
  background-color: var(--color-primary);
  color: var(--color-text-inverse);
}

/* Secondary variant: White background with primary color text */
.custom-card--secondary {
  background-color: var(--color-white);
  color: var(--color-primary);
  border: 1px solid var(--color-border-primary);
}

/* Transparent variant: No background with defined colors for title and description */
.custom-card--transparent {
  background-color: transparent;
  color: var(--color-text-primary);
  border: none;
  box-shadow: none;
}

.custom-card__content {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  justify-content: space-between;
}

.custom-card__title-container {
  display: flex;
  align-items: flex-start;
  gap: var(--space-sm);
}

.custom-card__title {
  font-family: var(--font-family-semibold);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
  margin: 0;
  flex: 1 1;
}

.custom-card__title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.custom-card__description-container {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.custom-card__description {
  font-family: var(--font-family-regular);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-normal);
  margin: 0;
  opacity: 0.9;
}

.custom-card__description-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Icon size variants */
.custom-card__title-icon--small {
  width: var(--icon-size-small);
  height: var(--icon-size-small);
}

.custom-card__title-icon--medium {
  width: var(--icon-size-medium);
  height: var(--icon-size-medium);
}

.custom-card__title-icon--large {
  width: var(--icon-size-large);
  height: var(--icon-size-large);
}

.custom-card__description-icon--small {
  width: var(--icon-size-xs);
  height: var(--icon-size-xs);
}

.custom-card__description-icon--medium {
  width: var(--icon-size-small);
  height: var(--icon-size-small);
}

.custom-card__description-icon--large {
  width: var(--icon-size-medium);
  height: var(--icon-size-medium);
}

/* Icon color inheritance */
.custom-card__title-icon svg,
.custom-card__description-icon svg {
  width: 100%;
  height: 100%;
  fill: currentColor;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-card {
    padding-top: var(--space-sm) !important;
    padding-bottom: var(--space-sm) !important;
  }
  
  .custom-card__title {
    font-size: var(--font-size-md);
  }
  
  .custom-card__description {
    font-size: var(--font-size-xs);
  }
}

/* Focus styles for accessibility */
.custom-card--clickable:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.custom-card--clickable:focus:not(:focus-visible) {
  outline: none;
}

/* Animation for smooth transitions */
.custom-card {
  will-change: transform, box-shadow;
}

/* Ensure proper text contrast */
.custom-card--primary .custom-card__description {
  opacity: 0.85;
}

.custom-card--secondary .custom-card__description {
  opacity: 0.7;
}

/* Transparent variant specific styling */
.custom-card--transparent .custom-card__title {
  color: var(--color-primary);
  font-weight: var(--font-weight-semibold);
}

.custom-card--transparent .custom-card__description {
  color: var(--color-text-secondary);
  opacity: 1;
}

/* Transparent variant hover effects */
.custom-card--transparent.custom-card--clickable:hover {
  background-color: rgba(33, 57, 88, 0.05);
  transform: translateY(-0.0625rem);
}

/* New flexible layout styles */
.custom-card__top-section,
.custom-card__bottom-section {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.custom-card__top-section {
  margin-bottom: auto;
}

.custom-card__bottom-section {
  margin-top: auto;
}

.custom-card__top-icon,
.custom-card__bottom-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.custom-card__top-component,
.custom-card__bottom-component {
  flex: 1 1;
  display: flex;
  align-items: center;
}

/* Icon color inheritance for new layout */
.custom-card__top-icon svg,
.custom-card__bottom-icon svg {
  width: 100%;
  height: 100%;
  fill: currentColor;
}
`, "",{"version":3,"sources":["webpack://./src/styles/CustomCard.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2DAA2D;EAC3D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,0DAA0D;AAC1D;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA,gEAAgE;AAChE;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,qFAAqF;AACrF;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,wCAAwC;EACxC,qCAAqC;EACrC,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,sCAAsC;EACtC,sCAAsC;EACtC,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,uCAAuC;IACvC,0CAA0C;EAC5C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,mCAAmC;AACnC;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;AACpC;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;;EAEE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/* CustomCard Component Styles */\n\n.custom-card {\n  border-radius: 20px;\n  padding-top: var(--space-sm);\n  display: flex;\n  flex-direction: column;\n  justify-content: top;\n  transition: all var(--duration-fast) var(--easing-ease-out);\n  position: relative;\n  overflow: hidden;\n}\n\n.custom-card--clickable {\n  cursor: pointer;\n}\n\n.custom-card--clickable:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.custom-card--clickable:active {\n  transform: translateY(0);\n}\n\n/* Primary variant: Dark blue background with white text */\n.custom-card--primary {\n  background-color: var(--color-primary);\n  color: var(--color-text-inverse);\n}\n\n/* Secondary variant: White background with primary color text */\n.custom-card--secondary {\n  background-color: var(--color-white);\n  color: var(--color-primary);\n  border: 1px solid var(--color-border-primary);\n}\n\n/* Transparent variant: No background with defined colors for title and description */\n.custom-card--transparent {\n  background-color: transparent;\n  color: var(--color-text-primary);\n  border: none;\n  box-shadow: none;\n}\n\n.custom-card__content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n  justify-content: space-between;\n}\n\n.custom-card__title-container {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-sm);\n}\n\n.custom-card__title {\n  font-family: var(--font-family-semibold);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-tight);\n  margin: 0;\n  flex: 1;\n}\n\n.custom-card__title-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.custom-card__description-container {\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.custom-card__description {\n  font-family: var(--font-family-regular);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-normal);\n  line-height: var(--line-height-normal);\n  margin: 0;\n  opacity: 0.9;\n}\n\n.custom-card__description-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* Icon size variants */\n.custom-card__title-icon--small {\n  width: var(--icon-size-small);\n  height: var(--icon-size-small);\n}\n\n.custom-card__title-icon--medium {\n  width: var(--icon-size-medium);\n  height: var(--icon-size-medium);\n}\n\n.custom-card__title-icon--large {\n  width: var(--icon-size-large);\n  height: var(--icon-size-large);\n}\n\n.custom-card__description-icon--small {\n  width: var(--icon-size-xs);\n  height: var(--icon-size-xs);\n}\n\n.custom-card__description-icon--medium {\n  width: var(--icon-size-small);\n  height: var(--icon-size-small);\n}\n\n.custom-card__description-icon--large {\n  width: var(--icon-size-medium);\n  height: var(--icon-size-medium);\n}\n\n/* Icon color inheritance */\n.custom-card__title-icon svg,\n.custom-card__description-icon svg {\n  width: 100%;\n  height: 100%;\n  fill: currentColor;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .custom-card {\n    padding-top: var(--space-sm) !important;\n    padding-bottom: var(--space-sm) !important;\n  }\n  \n  .custom-card__title {\n    font-size: var(--font-size-md);\n  }\n  \n  .custom-card__description {\n    font-size: var(--font-size-xs);\n  }\n}\n\n/* Focus styles for accessibility */\n.custom-card--clickable:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n.custom-card--clickable:focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* Animation for smooth transitions */\n.custom-card {\n  will-change: transform, box-shadow;\n}\n\n/* Ensure proper text contrast */\n.custom-card--primary .custom-card__description {\n  opacity: 0.85;\n}\n\n.custom-card--secondary .custom-card__description {\n  opacity: 0.7;\n}\n\n/* Transparent variant specific styling */\n.custom-card--transparent .custom-card__title {\n  color: var(--color-primary);\n  font-weight: var(--font-weight-semibold);\n}\n\n.custom-card--transparent .custom-card__description {\n  color: var(--color-text-secondary);\n  opacity: 1;\n}\n\n/* Transparent variant hover effects */\n.custom-card--transparent.custom-card--clickable:hover {\n  background-color: rgba(33, 57, 88, 0.05);\n  transform: translateY(-0.0625rem);\n}\n\n/* New flexible layout styles */\n.custom-card__top-section,\n.custom-card__bottom-section {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.custom-card__top-section {\n  margin-bottom: auto;\n}\n\n.custom-card__bottom-section {\n  margin-top: auto;\n}\n\n.custom-card__top-icon,\n.custom-card__bottom-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.custom-card__top-component,\n.custom-card__bottom-component {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n/* Icon color inheritance for new layout */\n.custom-card__top-icon svg,\n.custom-card__bottom-icon svg {\n  width: 100%;\n  height: 100%;\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
